<template>
  <section>
    <div class="container is-grid">
      <div class="is-col-12-md">
        <h1>
          CURRICULUM &<br class="show-br-header"/> SOCIAL MEDIA ASSETS </h1>
        <div class="superhero-image-curriculum">
          <img src="@/assets/images/global/super-hero-4.gif"/>
        </div>
        <SunHeroGuideRow/>
        <SunHeroSocialMediaRow/>
      </div>
    </div>
  </section>
</template>
<script>
import SunHeroGuideRow from '../curriculum/SunHeroGuideRow.vue'
import SunHeroSocialMediaRow from '../curriculum/SunHeroSocialMediaRow.vue'

export default {
  components: {
    SunHeroGuideRow,
    SunHeroSocialMediaRow
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

h1 {
  font-size: 60px;
  margin-top: 65px;
  text-align: left;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    text-align: center;
    font-size: 45px;
    margin-top: 1.1em;
  }
}

.show-br-header {
  display: none;
  @media screen and (max-width: 1000px) {
    display: block;
  }
}

.superhero-image-curriculum {
  width: 302px;
  height: auto;
  position: absolute;
  left: 80%;
  top: 5%;
  z-index: 14;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: none;
    width: 27%;
    top: 7%;
    left: 65%;
  }
  @media screen and (max-width: 500) {
    display: none;
  }

  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>
